import { createSlice } from '@reduxjs/toolkit';

let initialState = {
    loading: false,
    postRes: null,
    getRes: null,
    getByIdRes: null,
    putRes: null,
    deleteRes: null,
};

const slice = createSlice({
    name: 'labSpecimenType',
    initialState,
    reducers: {
        postLabSpecimenTypeRequest: (state) => {
            state.loading = true;
        },
        postLabSpecimenTypeSuccess: (state, action) => {
            state.loading = false;
            state.postRes = action.payload;
        },
        postLabSpecimenTypeFailure: (state, action) => {
            state.loading = false;
            state.postRes = action.payload;
        },
        resetPostLabSpecimenType: (state) => {
            state.postRes = null;
        },

        getLabSpecimenTypeRequest: (state) => {
            state.loading = true;
        },
        getLabSpecimenTypeSuccess: (state, action) => {
            state.loading = false;
            state.getRes = action.payload;
        },
        getLabSpecimenTypeFailure: (state, action) => {
            state.loading = false;
            state.getRes = action.payload;
        },
        resetGetLabSpecimenType: (state) => {
            state.getRes = null;
        },

        getLabSpecimenTypeByIdRequest: (state) => {
            state.loading = true;
        },
        getLabSpecimenTypeByIdSuccess: (state, action) => {
            state.loading = false;
            state.getByIdRes = action.payload;
        },
        getLabSpecimenTypeByIdFailure: (state, action) => {
            state.loading = false;
            state.getByIdRes = action.payload;
        },
        resetGetLabSpecimenTypeById: (state) => {
            state.getByIdRes = null;
        },

        putLabSpecimenTypeRequest: (state) => {
            state.loading = true;
        },
        putLabSpecimenTypeSuccess: (state, action) => {
            state.loading = false;
            state.putRes = action.payload;
        },
        putLabSpecimenTypeFailure: (state, action) => {
            state.loading = false;
            state.putRes = action.payload;
        },
        resetPutLabSpecimenType: (state) => {
            state.putRes = null;
        },

        deleteLabSpecimenTypeRequest: (state) => {
            state.loading = true;
        },
        deleteLabSpecimenTypeSuccess: (state, action) => {
            state.loading = false;
            state.deleteRes = action.payload;
        },
        deleteLabSpecimenTypeFailure: (state, action) => {
            state.loading = false;
            state.deleteRes = action.payload;
        },
        resetDeleteLabSpecimenType: (state) => {
            state.deleteRes = null;
        },
    }
});

export const {
    postLabSpecimenTypeRequest, postLabSpecimenTypeSuccess, postLabSpecimenTypeFailure, resetPostLabSpecimenType,
    getLabSpecimenTypeRequest, getLabSpecimenTypeSuccess, getLabSpecimenTypeFailure, resetGetLabSpecimenType,
    getLabSpecimenTypeByIdRequest, getLabSpecimenTypeByIdSuccess, getLabSpecimenTypeByIdFailure, resetGetLabSpecimenTypeById,
    putLabSpecimenTypeRequest, putLabSpecimenTypeSuccess, putLabSpecimenTypeFailure, resetPutLabSpecimenType,
    deleteLabSpecimenTypeRequest, deleteLabSpecimenTypeSuccess, deleteLabSpecimenTypeFailure, resetDeleteLabSpecimenType,
} = slice.actions;

export default slice.reducer;
